import React, { useState, useRef } from "react";
import { Row, Col, Breadcrumb, Menu, message } from "antd";
import { HomeOutlined, UnorderedListOutlined, InfoCircleOutlined, ContactsOutlined, BellOutlined, SettingOutlined } from "@ant-design/icons";
import CompanyTable from "./CompanyTable";

const SIDEBAR_KEYS = {
  COMPANY_LIST: "company-list",
  GENERAL_INFO: "general-info",
  CONTACT: "contact",
  NOTIFICATION: "notification",
  CONFIGURATION: "configuration",
};

const SETTINGS_STEP_INDEX = {
  [SIDEBAR_KEYS.GENERAL_INFO]: 0,
  [SIDEBAR_KEYS.CONTACT]: 1,
  [SIDEBAR_KEYS.CONFIGURATION]: 2,
  [SIDEBAR_KEYS.NOTIFICATION]: 3,
};

const sidebarItems = [
  { key: SIDEBAR_KEYS.COMPANY_LIST, icon: <UnorderedListOutlined />, label: "Company List" },
  { type: "divider" },
  { type: "group", label: "Settings", children: [
    { key: SIDEBAR_KEYS.GENERAL_INFO, icon: <InfoCircleOutlined />, label: "General Info" },
    { key: SIDEBAR_KEYS.CONTACT, icon: <ContactsOutlined />, label: "Contact" },
    { key: SIDEBAR_KEYS.CONFIGURATION, icon: <SettingOutlined />, label: "Configuration" },
    { key: SIDEBAR_KEYS.NOTIFICATION, icon: <BellOutlined />, label: "Notification" },
  ]},
];

export default function Company() {
  const [selectedKey, setSelectedKey] = useState(SIDEBAR_KEYS.COMPANY_LIST);
  const tableRef = useRef();

  const handleMenuClick = ({ key }) => {
    setSelectedKey(key);
    const stepIndex = SETTINGS_STEP_INDEX[key];
    if (stepIndex !== undefined) {
      const companyId = localStorage.getItem("companyId");
      if (!companyId || companyId === "" || companyId === "Select Company") {
        message.warning("Please select a Group and Company from the header first.");
        return;
      }
      tableRef.current?.openEditDrawer(companyId, stepIndex);
    }
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item href="/dashboard">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Business Entity</Breadcrumb.Item>
        <Breadcrumb.Item>Companies</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={24} align="top">
        <Col xs={24} sm={24} md={6} lg={5} xl={4}>
          <aside className="company-sidebar-nav">
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              items={sidebarItems}
              onClick={handleMenuClick}
              className="company-sidebar-menu"
              style={{
                height: "calc(100vh - 300px)",
                minHeight: 280,
                borderInlineEnd: "none",
                background: "transparent",
              }}
            />
          </aside>
        </Col>
        <Col xs={24} sm={24} md={18} lg={19} xl={20}>
          <div style={{ marginTop: "16px", marginBottom: 24 }}>
            <CompanyTable ref={tableRef} onEditDrawerClose={() => setSelectedKey(SIDEBAR_KEYS.COMPANY_LIST)} />
          </div>
        </Col>
      </Row>
    </>
  );
}
